import React, { useEffect, useState } from 'react';
import { getLocale, useIntl, useSelector } from 'umi';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getDateVal, getDynamicLocalCnEnText } from '@/pages/dashboard/utils/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getFunnelText } from '@/pages/dashboard/pages/funnel/_config/constant';
import { LANGUAGE_CN, LANGUAGE_EN } from '@/pages/dashboard/_config/constant';
import { RANGE_DAY_MONTH } from '../FilterBase/_config';
import { getCustomFilterList } from '../customFilterList';
import { isNewCascadeFilter } from '../util';

// import './index.scss'

// 筛选器选项值字段映射
const FLITER_MAP_KEY = {
  channel: {
    key: 'channel_id',
    enName: 'channel_name_en',
    cnName: 'channel_name_ch',
  },
  system: {
    key: 'os_id',
    enName: 'os_name_en',
    cnName: 'os_name_ch',
  },
  os: {
    key: 'os_id',
    enName: 'os_name_en',
    cnName: 'os_name_ch',
  },
  zone: {
    key: 'zone_code',
    enName: 'zone_name_en',
    cnName: 'zone_name_ch',
  },
  country: {
    key: 'country_code',
    enName: 'country_name_en',
    cnName: 'country_name_ch',
  },
  language: {
    key: 'lang_code',
    enName: 'lang_name_en',
    cnName: 'lang_name_ch',
  },
  lang: {
    key: 'lang_code',
    enName: 'lang_name_en',
    cnName: 'lang_name_ch',
  },
  bundle: {
    key: 'bundle_id',
    enName: 'bundle_name_en',
    cnName: 'bundle_name_ch',
  },
  product: {
    key: 'product_code',
    enName: 'product_name_en',
    cnName: 'product_name_ch',
  },
  churn_level: {
    key: 'churn_level',
    enName: 'churn_level_en',
    cnName: 'churn_level_ch',
  },
};

export const FilterTitle = (props: {
  className?: string;
  realInputList: any;
  gameCode: any;
  formValue?: any;
  outSelector: any;
  stickyTrailingSlot?: React.ReactNode;
}) => {
  const {
    className = '',
    realInputList: oldRealInputList,
    gameCode,
    formValue = {},
    outSelector,
    stickyTrailingSlot,
  } = props;

  // review
  const realInputList = oldRealInputList?.filter((v: any) => v?.visible !== 0);
  const { selector } = useSelector((state: any) => state?.dashboardSetting ?? {});
  const { locale, getLocalText } = useLocal('filter');
  const { formatMessage } = useIntl();
  const [regionValue, setRegionValue] = useState('');
  const [categoryValue, setCategoryValue] = useState('');
  // 存储所有级联筛选器的 DOM 内容，key 是筛选器的 key，value 是 DOM 内容
  const [cascadeFilterValues, setCascadeFilterValues] = useState<{ [key: string]: string }>({});
  const seleterSaveFilterDom = document.getElementById('select-save-filter');
  const seleterSaveFilter = seleterSaveFilterDom?.innerText || '';
  const customFilterList = getCustomFilterList();

  // 单独日周月类型时间筛选器
  const rangeTimeList = ['rangeDaily', 'rangeWeekly', 'rangeMonthly'];
  // 维度类型筛选器
  const dimensionList = [
    'zone',
    'region',
    'channel',
    'system',
    'lang',
    'networkType',
    'mediaChannel',
    'churn_level',
    'bundle',
    'metrics'
  ];
  // 漏斗页面维度类型筛选器
  const funnelDimensionList = [
    'appVersion',
    'networkType',
    'memory',
    'storeChannel',
    'stage'
  ];
  const getTitle = (data: { name_en: string; name_cn: string; }) => {
    const { name_en: nameEn, name_cn: nameCn } = data || {};
    const label = locale === LANGUAGE_EN ? nameEn?.slice(0, 1)?.toUpperCase() + nameEn?.slice(1)?.toLowerCase() : nameCn;
    return label;
  };
  const filterOptions = [
    {
      key: 'zone',
      title: getLocalText(`selector_multiple_component_zone_label`, {}, false),
      allDescribe: getLocalText(
        `selector_multiple_component_zone_all_describe`,
        {},
        false,
      ),
    },
    // {
    //   key: 'region',
    //   title: getLocalText(`selector_multiple_component_region_label`, {}, false),
    //   allDescribe: getLocalText(`selector_multiple_component_region_all_describe`, {}, false),
    // },
    {
      key: 'channel',
      title: getLocalText(
        `selector_multiple_component_channel_label`,
        {},
        false,
      ),
      allDescribe: getLocalText(
        `selector_multiple_component_channel_all_describe`,
        {},
        false,
      ),
    },
    {
      key: 'system',
      title: getLocalText(
        `selector_multiple_component_system_label`,
        {},
        false,
      ),
      allDescribe: getLocalText(
        `selector_multiple_component_system_all_describe`,
        {},
        false,
      ),
    },
    {
      key: 'lang',
      title: getLocalText(
        `selector_multiple_component_language_label`,
        {},
        false,
      ),
      allDescribe: getLocalText(
        `selector_multiple_component_language_all_describe`,
        {},
        false,
      ),
    },
    {
      key: 'bundle',
      title: getTitle,
      allDescribe: getLocalText('selector_multiple_component_common_all_describe', {}, false),
    },
    // UA相关筛选器
    {
      key: 'networkType',
      title: getLocalText(
        'selector_multiple_component_network_label',
        {},
        false,
      ),
      allDescribe: getLocalText(
        'selector_multiple_component_network_all_describe',
        {},
        false,
      ),
    },
    {
      key: 'mediaChannel',
      title: getLocalText('selector_multiple_component_media_label', {}, false),
      allDescribe: getLocalText(
        'selector_multiple_component_media_all_describe',
        {},
        false,
      ),
    },
    // competitor相关筛选器
    {
      key: 'competitor',
      title: getLocalText(
        'selector_multiple_component_competitor_label',
        {},
        false,
      ),
      allDescribe: getLocalText(
        'selector_multiple_component_competitor_all_describe',
        {},
        false,
      ),
    },
    {
      key: 'source',
      title: getLocalText('competitor_source', {}, false),
    },
    // Competitor Launch time 时间筛选器
    {
      key: 'rangeDayMonth',
      title: formatMessage({ id: 'competitor_launch' }),
    },
    // Realtime 对比日时间筛选器
    {
      key: 'contrastDaily',
      title: formatMessage({ id: 'contrast day' }),
    },
    // Date Comparison 时间筛选器
    {
      key: 'statisticDate',
      title: formatMessage({
        id: 'comparison_analysis_date_comparison_statistics_date',
      }),
    },
    {
      key: 'contrastDate',
      title: formatMessage({
        id: 'comparison_analysis_date_comparison_contrast_date',
      }),
    },
    // 漏斗分析筛选器
    {
      key: 'appVersion',
      title: formatMessage({
        id: 'selector_multiple_component_app_version_label',
      }),
      allDescribe: getLocalText(
        'selector_multiple_component_media_all_describe',
        {},
        false,
      ),
    },
    {
      key: 'memory',
      title: formatMessage({
        id: 'selector_multiple_component_memory_label',
      }),
      allDescribe: getLocalText(
        'selector_multiple_component_media_all_describe',
        {},
        false,
      ),
    },
    {
      key: 'storeChannel',
      title: formatMessage({
        id: 'selector_multiple_component_store_channel_label',
      }),
      allDescribe: getLocalText(
        'selector_multiple_component_store_channel_all_describe',
        {},
        false,
      ),
    },
    {
      key: 'stage',
      title: formatMessage({ id: 'selector_multiple_component_step_label' }),
      allDescribe: getLocalText(
        'selector_multiple_component_step_describe',
        {},
        false,
      ),
    },
    {
      key: 'churn_level',
      title: formatMessage({ id: 'common_Churn_level' }),
      allDescribe: getLocalText(
        'selector_multiple_component_step_describe',
        {},
        false,
      ),
    },
    {
      key: 'metrics',
      title: formatMessage({ id: 'selector_multiple_component_metrics_label' }),
      allDescribe: getLocalText(
        'selector_multiple_component_step_describe',
        {},
        false,
      ),
    },
    // {
    //   key: 'category',
    //   title: formatMessage({ id: 'common_Category' }),
    // },
  ];

  /**
   * 获取所有级联筛选器的 DOM 内容
   * 参照 region 筛选器的方案，直接从 DOM 中获取 RegionSelectButton 渲染的内容
   * @param realInputList - 筛选器配置列表
   * @returns 级联筛选器的 DOM 内容对象，key 是筛选器的 key，value 是 DOM 的 innerHTML
   */
  const getCascadeFilterValues = (realInputList: any[]): { [key: string]: string } => {
    const cascadeValues: { [key: string]: string } = {};
    
    if (!realInputList || realInputList.length === 0) {
      return cascadeValues;
    }
    
    realInputList.forEach((item: any) => {
      const key = item?.key || item?.type;
      
      // 判断是否是新级联筛选器（排除 region 和 category）
      if (isNewCascadeFilter(item, key)) {
        // 级联筛选器的 id 格式：${filterKey}_cascade-input
        // 与 CascadeFilterComponent 中的 selectFilterType={`${filterKey}_cascade`} 对应
        const cascadeId = `${key}_cascade-input`;
        
        try {
          // 从 DOM 中获取级联筛选器的渲染内容
          // 使用 try-catch 防止 DOM 操作失败导致页面崩溃
          const cascadeElement = document.getElementById(cascadeId);
          const cascadeInnerHtml = cascadeElement?.innerHTML || '';
          
          if (cascadeInnerHtml) {
            cascadeValues[key] = cascadeInnerHtml;
          }
        } catch (error) {
          // 如果获取 DOM 失败，记录警告但不影响其他筛选器的处理
          console.warn(`Failed to get DOM content for cascade filter ${key}:`, error);
        }
      }
    });
    
    return cascadeValues;
  };

  /**
   * 当 formValue 变化时，更新 region、category 和级联筛选器的显示值
   * 通过从 DOM 中获取 RegionSelectButton 渲染的内容来更新显示
   */
  useEffect(() => {
    // 获取 region 筛选器的 DOM 内容
    const regionInnerHtml =
      document.getElementById('region-input')?.innerHTML || '';
    if (regionInnerHtml) {
      setRegionValue(regionInnerHtml);
    }
    
    // 获取 category 筛选器的 DOM 内容
    const categoryInnerHtml =
      document.getElementById('category-input')?.innerHTML || '';
    if (categoryInnerHtml) {
      setCategoryValue(categoryInnerHtml);
    }
    
    // 动态获取所有级联筛选器的 DOM 内容
    const cascadeValues = getCascadeFilterValues(realInputList);
    if (Object.keys(cascadeValues).length > 0) {
      setCascadeFilterValues(cascadeValues);
    }
  }, [JSON.stringify(formValue)]);

  /**
 * 当语言环境变化时，更新 region、category 和级联筛选器的显示值
 * 使用 setTimeout 确保 DOM 已经更新完成
 */
  useEffect(() => {
    const timer = setTimeout(() => {
      // 获取 region 筛选器的 DOM 内容
      const value = document.getElementById('region-input')?.innerHTML || '';
      setRegionValue(value);
      
      // 获取 category 筛选器的 DOM 内容
      const categoryValue = document.getElementById('category-input')?.innerHTML || '';
      setCategoryValue(categoryValue);
      
      // 动态获取所有级联筛选器的 DOM 内容
      const cascadeValues = getCascadeFilterValues(realInputList);
      if (Object.keys(cascadeValues).length > 0) {
        setCascadeFilterValues(cascadeValues);
      }
    }, 10);

    // 清理函数：组件卸载或依赖变化时清除定时器
    return () => {
      clearTimeout(timer);
    };
  }, [locale]);

  const renderTitle = (key: string) => {
    // 根据后端配置筛选器展示名称
    const customFilter = realInputList?.find((item: { key: string; }) => item?.key === key);
    if (customFilter) {
      const { name_en: nameEn, name_cn: nameCn } = customFilter || {};
      const name = locale === LANGUAGE_CN && nameCn ? nameCn : nameEn;
      if (name) return name;
    }
    // 原有根据前端配置的映射展示名称
    const dimension = filterOptions?.find((item) => item?.key === key);
    if (typeof (dimension?.title) === 'function') {
      const dimensionData = realInputList?.find((item: any) => item?.key === key);
      return dimension?.title(dimensionData);
      // eslint-disable-next-line no-else-return
    } else if (dimension?.key === RANGE_DAY_MONTH) {
      const dimensionData = realInputList?.find((item: any) => item?.key === key);
      if (dimensionData) {
        return formatMessage({ id: dimensionData.alignedBy?.textId || 'competitor_launch' });
      }
    }
    return dimension?.title;
  };

  const renderTime = (key: string, type: string) => {
    const optionsMap: any = {
      hour: { value: "hour", text: "Hour", text_cn: '时' },
      date: { value: "date", text: "Day", text_cn: '日' },
      week: { value: "week", text: "Week", text_cn: '周' },
      month: { value: "month", text: "Month", text_cn: '月' },
      year: { value: "year", text: "Year", text_cn: '年' },
      singleDaily: { value: "date", text: "Day", text_cn: '日' },
      rangeDaily: { value: "date", text: "Day", text_cn: '日' },
      rangeWeekly: { value: "week", text: "Week", text_cn: '周' },
      rangeMonthly: { value: "month", text: "Month", text_cn: '月' },
    };
    if (type === 'rangeDate') {
      // 多粒度日期筛选器
      const timeType = formValue?.[key]?.type;
      return locale === 'zh-CN' ? optionsMap?.[timeType]?.text_cn : optionsMap?.[timeType]?.text;
    }
    return locale === 'zh-CN' ? optionsMap?.[type]?.text_cn : optionsMap?.[type]?.text;
  };
  const renderValue = (key: string, type: string, options?: any) => {
    if (JSON.stringify(formValue) === '{}') return null;
    if (key === 'metrics') return formatMetricsValue(key, formValue?.[key]);
    if (dimensionList?.includes(key) || funnelDimensionList?.includes(key)) {
      return formatDimensionValue(key, formValue?.[key], options);
    }
    //  时间对比(statisticDate,contrastDate)
    if (
      key === 'rangeTime' ||
      key === 'statisticDate' ||
      key === 'contrastDate'
    )
      return formatTimeValue(key, type);
    // realtime 时间类型筛选器(singleDaily,contrastDaily) competitor 来源筛选器（source）
    if (key === 'singleDaily' || key === 'contrastDaily') {
      return formValue?.[key] || null;
    }
    if (key === 'source') {
      return formatSourceValue(key);
    }
    // competitor Launch time 筛选器
    if (key === 'rangeDayMonth') {
      const prefix = formValue?.[key]?.type?.slice?.(0, 1)?.toUpperCase?.();
      const value = formValue?.[key]?.value || [];
      return `${prefix}${value?.[0]} ~ ${prefix}${value?.[1]}`;
    }
    // 竞品筛选器
    if (key === 'competitor') return formatCompetitorValue(key, formValue?.[key]);
    // 后端配置的筛选器
    const customFilter = realInputList?.find((item: { key: string; }) => item?.key === key);
    if (customFilter && customFilterList?.includes(customFilter?.key)) return formatCustomFilterValue(customFilter, formValue?.[key]);
    return null;
  };

  /**
   * 后端配置的筛选器吸顶值的展示
   * 注意：新的级联筛选器现在使用 DOM 方案（getCascadeFilterValues），此函数主要用于非级联的自定义筛选器
   * @param customFilter - 筛选器配置项
   * @param value - 筛选器的值
   * @returns 格式化后的显示文本
   */
  const formatCustomFilterValue = (customFilter: any, value: string[] | null) => {
    let processedValue: string[] | null = value;
    
    // 判断是否是新级联筛选器（排除 region 和 category）
    const key = customFilter?.key || customFilter?.type;
    const isNewCascade = isNewCascadeFilter(customFilter, key);
    
    // 只有新级联筛选器才需要处理对象格式：{ parent: [...], [key]: [...], type: parentKey | childKey }
    // 注意：新的级联筛选器现在优先使用 DOM 方案，这里作为兜底处理
    if (isNewCascade && value && typeof value === 'object' && !Array.isArray(value) && (value as any).type) {
      // 级联筛选器：提取子值（childKey 就是筛选器的 key）
      const cascadeValue = (value as any)[key] || [];
      processedValue = Array.isArray(cascadeValue) ? cascadeValue : [];
    }
    
    // 普通自定义筛选器的值应该是数组格式，直接使用
    const valueIsString = typeof processedValue === 'string';
    const val = (valueIsString && processedValue) ? [processedValue] : processedValue;
    if (val === null) return null;
    if (!Array.isArray(val)) return null; // 如果不是数组，返回 null
    const firstVal = val?.[0];
    if (((firstVal === '255' || (typeof firstVal === 'string' && firstVal?.toLocaleLowerCase() === 'all')) && val?.length ===1) ) {
      return getLocalText(`selector_multiple_component_custom_filter_all_describe`, {}, false,);
      // eslint-disable-next-line no-else-return
    } else {
      if (val?.length > 2) return val?.length;
      const dimensionNameList = val?.map((item: any) => {
        const dimensionValue = customFilter?.options?.find((v: { code: any; }) => v?.code === item);
        const { name_en: nameEn, name_ch: nameCn } = dimensionValue || {};
        return locale === LANGUAGE_CN && nameCn ? nameCn : nameEn || '';
      });
      return dimensionNameList?.toString?.() || null;
    }
  };

  const formatSourceValue = (key: string): string => {
    const SOURCE_MAP: any = {
      ogdb: "Databrain",
      appannie: "Data.ai",
      sensortower: "Sensor Tower",
    };
    return SOURCE_MAP[formValue?.[key]] || null;
  };

  const formatTimeValue = (key: string, type: string) => {
    if (rangeTimeList?.includes(type)) {
      // 单独日周月类型时间筛选器
      const rangeTimeFormat =
        type === 'rangeMonthly' ? 'YYYY-MM' : 'YYYY-MM-DD';
      return (`${getDateVal(formValue?.[key]?.[0], rangeTimeFormat)}~${getDateVal(formValue?.[key]?.[1], rangeTimeFormat)}`);
    }
    const dateFormat =
      formValue?.[key]?.type === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD';
    return (`${getDateVal(formValue?.[key]?.value?.[0], dateFormat)}~${getDateVal(formValue?.[key]?.value?.[1], dateFormat)}`
    );
  };

  const formatDimensionValue = (key: any, value: string[] | null, options?: any) => {
    const keyVal = key === 'lang' ? 'language' : key;
    if (value === null) return null; 
    if (value?.[0] === '255') {
      return filterOptions?.find((item) => item?.key === key)?.allDescribe;
      // eslint-disable-next-line no-else-return
    } else {
      if (value?.length > 2) return value?.length;

      const dimensionNameList = value?.map((item: any) => {
        if (funnelDimensionList?.includes(keyVal) && outSelector) {
          const funnelKeyMap: any = {
            appVersion: 'app_version',
            networkType: 'network_type',
            memory: 'memory',
            storeChannel: 'store_channel',
            stage: 'stage',
          };
          return getFunnelText(funnelKeyMap?.[keyVal] || keyVal, item, gameCode, getLocale(), outSelector)?.replace?.(/<[^>]+>/gim, '');
        }

        // 匹配对应选项
        const { key: mapKey, enName, cnName } = (FLITER_MAP_KEY as any)[key] || {};
        const selectOpt = options?.find((opt: any) => item === opt?.[mapKey]);
        // 如果选项带图标
        if (selectOpt?.icon) {
          const dom = (
            <span key={selectOpt}>
              <img src={selectOpt.icon} />
              {locale === LANGUAGE_CN ? selectOpt[cnName] : selectOpt[enName]}
            </span>
          );
          return dom;
        }
        const dom = getDynamicLocalCnEnText(keyVal, item, gameCode, getLocale(), outSelector || selector)?.replace?.(/<[^>]+>/gim, '');
        return dom;
      });
      // 中间使用逗号隔开
      return dimensionNameList?.reduce((acc, item, index) => {
        if (index === 0) {
          return [item];
        }
        return [...acc, ',', item];
      }, []) || null;
    }
  };

  const formatMetricsValue = (key: any, value: string[] | null) => {
    if (value === null) return null;
    if (value?.length > 2) return value?.length;
    const metricsList = outSelector?.metrics_list || [];
    const metricsNameList = value?.map((item: any) => {
      const metric = metricsList?.find((v: any) => v?.metric === item);
      return getLocale() === 'en-US' ? metric?.metric_name_en : metric?.metric_name_ch;
    });
    return metricsNameList?.toString?.() || null;
  };

  const formatCompetitorValue = (key: any, value: string[] | null) => {
    if (value === null) return null;
    const competitorOptions =
      realInputList?.find((item: { key: string; }) => item?.key === key)
        ?.options || [];
    if (value?.length === competitorOptions?.length) {
      return filterOptions?.find((item) => item?.key === key)?.allDescribe;
      // eslint-disable-next-line no-else-return
    } else {
      if (value?.length > 2) return value?.length;
      const competitorNameList = value?.map(
        (item: any) =>
          competitorOptions?.find(
            (cItem: { unified_id: any; }) => cItem?.unified_id === item,
          )?.name,
      );
      return competitorNameList?.toString?.() || null;
    }
  };

  return (
    <div className={`dbd-filter-content-title ${className}`}>
      <div className="dbd-filter-content-title-item">
        <SvgIcon type="funnel" className="title-item-icon" />
        {seleterSaveFilter && <span
          className={`${seleterSaveFilter === formatMessage({ id: 'filter_save_my_filter' }) ? "dbd-filter-content-title-item-name" : ""}`}
          dangerouslySetInnerHTML={{ __html: seleterSaveFilter?.length >= 20 ? `${seleterSaveFilter?.slice(0, 20)}...` : seleterSaveFilter }}>
        </span>}
      </div>
      {realInputList?.map(({ key, type, options }: { key: string; type: string; options?: any; }) => {
        if (key === 'region') {
          return (
            formValue?.[key] && (
              <div
                key={key}
                className="dbd-filter-content-title-item"
                dangerouslySetInnerHTML={{ __html: regionValue }}
              />
            )
          );
        }

        if (key === 'category') {
          return (
            formValue?.[key] && (
              <div
                key={key}
                className="dbd-filter-content-title-item"
                dangerouslySetInnerHTML={{ __html: categoryValue }}
              />
            )
          );
        }

        // 处理新的级联筛选器（排除 region 和 category）
        // 参照 region 筛选器的方案，直接从 DOM 中获取 RegionSelectButton 渲染的内容
        const currentFilter = realInputList?.find((item: any) => item?.key === key);
        const isNewCascade = isNewCascadeFilter(currentFilter, key);
        
        if (isNewCascade && cascadeFilterValues[key]) {
          return (
            formValue?.[key] && (
              <div
                key={key}
                className="dbd-filter-content-title-item"
                dangerouslySetInnerHTML={{ __html: cascadeFilterValues[key] }}
              />
            )
          );
        }

        if (renderValue(key, type) === null) return null;
        return (
          <div className="dbd-filter-content-title-item dbd-filter-content-title-dim-item" key={key}>
            <span className="dbd-filter-content-title-item-name">
              {key === 'rangeTime' || key === 'singleDaily' ? renderTime(key, type) : renderTitle(key)}
            </span>
            {renderValue(key, type, options)}
          </div>
        );
      })}
      {stickyTrailingSlot}
      <div className="dbd-filter-content-title-button">
        {getLocalText(`show_message`)}
        <div className="dbd-filter-content-title-button-down" />
      </div>
    </div>
  );
};
